import { dealerLabel } from "@/lib/naming";
import { pluralizeUnit } from "@/lib/statusLabels";

const FORMAT = { "4x4": "4×4", "2x6": "2×6", "2x2": "2×2" };

// ID-012: one readable row per sample product — SKU | Product name | Format | Quantity
export function sampleLineParts(l) {
  const full = dealerLabel(l) || l.variant_label || "";
  const [name] = full.split(" · ");
  return { sku: l.sku || "", name: name || full, format: FORMAT[l.format_in] || l.format_in || "", qty: `${l.quantity} ${pluralizeUnit(l.quantity_unit, l.quantity)}` };
}

export function SampleLine({ line, testid, children }) {
  const p = sampleLineParts(line);
  return (
    <p className="flex flex-wrap items-baseline gap-x-2 text-sm text-charcoal" data-testid={testid}>
      <span className="font-mono text-xs font-semibold text-terracotta" data-testid={testid ? `${testid}-sku` : undefined}>{p.sku || "SKU —"}</span>
      <span className="text-limestone">|</span>
      <span className="font-medium">{p.name}</span>
      {p.format && (<><span className="text-limestone">|</span><span className="text-warmgrey">{p.format}</span></>)}
      <span className="text-limestone">|</span>
      <span className="text-muted-foreground">{p.qty}</span>
      {children}
    </p>
  );
}
